exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".poll-details label {\n\twidth:50%;\n\tfloat:left;\n}\n.poll-details label.f-bold {\n\tfont-weight:bold;\n}\n.poll-details label span {\n\tpadding:0 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/poll-list/poll-list.component.css
// module id = ../../../../../src/app/event/poll-list/poll-list.component.css
// module chunks = main